<template>
  <div class="profile-page">
    <section class="section-profile-cover section-shaped my-0">
      <div class="shape shape-style-1 shape-primary shape-skew alpha-4">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
    </section>
    <section class="section section-skew">
      <div class="container">
        <card shadow class="card-profile mt-400" no-body>
          <div class="px-4">
            <form action method="post" id="profile">
              <div class="row mb-5">
                <div class="col-lg-12 col-sm-12 mt-3">
                  <h2>Profile</h2>
                  <hr />
                </div>
                <div class="col-lg-4 col-sm-12">
                  <base-input
                    name="fullname"
                    alternative
                    placeholder="FullName"
                    v-model="name"
                  ></base-input>
                </div>
                <div class="col-lg-4 col-sm-12">
                  <base-input
                    name="emilid"
                    alternative
                    placeholder="Email-Id"
                    v-model="email"
                  ></base-input>
                </div>
                <div class="col-lg-4 col-sm-12">
                  <base-input
                    name="phone"
                    alternative
                    placeholder="Phone No"
                    v-model="phone"
                  ></base-input>
                </div>
                <div class="col-lg-12 col-sm-12 mb-3">
                  <h2>
                    Billing Address
                    <hr />
                  </h2>
                </div>
                <div class="col-lg-12 col-sm-12 mb-3">
                  <textarea
                    class="form-control form-control-alternative"
                    name="address"
                    rows="3"
                    cols="40"
                    placeholder="Address"
                    v-model="bill_address.address"
                  ></textarea>
                </div>
                <div class="col-lg-4 col-sm-12">
                  <base-input
                    name="street"
                    alternative
                    placeholder="Street"
                    v-model="bill_address.street"
                  ></base-input>
                </div>
                <div class="col-lg-4 col-sm-12">
                  <base-input
                    name="town"
                    alternative
                    placeholder="Town"
                    v-model="bill_address.town"
                  ></base-input>
                </div>
                <div class="col-lg-4 col-sm-12">
                  <base-input
                    name="pincode"
                    alternative
                    placeholder="Pin-code"
                    v-model="bill_address.pincode"
                  ></base-input>
                </div>
                <div class="col-lg-4 col-sm-12">
                  <base-input
                    name="city"
                    alternative
                    placeholder="City"
                    v-model="bill_address.city"
                  ></base-input>
                </div>
                <div class="col-lg-4 col-sm-12">
                  <base-input
                    name="state"
                    alternative
                    placeholder="State"
                    v-model="bill_address.state"
                  ></base-input>
                </div>
                <div class="col-lg-4 col-sm-12">
                  <base-input
                    name="country"
                    alternative
                    placeholder="Country"
                    v-model="bill_address.country"
                  ></base-input>
                </div>
                <div class="col-lg-12 col-sm-12 mb-3">
                  <h2>
                    Shipping Address
                    <hr />
                  </h2>

                  <input
                    type="checkbox"
                    id="sameaddress"
                    name="sameaddress"
                    value="No"
                    @change="copyBilling"
                    v-model="ssame"
                  />&nbsp;
                  <label for="sameaddress"> Same as Billing Address</label
                  ><br />
                </div>
                <div class="col-lg-12 col-sm-12 mb-3">
                  <textarea
                    class="form-control form-control-alternative"
                    name="shippingaddress"
                    rows="3"
                    cols="40"
                    placeholder="Shipping Address"
                    v-model="shipping_address.address"
                  ></textarea>
                </div>
                <div class="col-lg-4 col-sm-12">
                  <base-input
                    name="shippingstreet"
                    alternative
                    placeholder="Shipping Street"
                    v-model="shipping_address.street"
                  ></base-input>
                </div>
                <div class="col-lg-4 col-sm-12">
                  <base-input
                    name="shippingtown"
                    alternative
                    placeholder="Shipping Town"
                    v-model="shipping_address.town"
                  ></base-input>
                </div>
                <div class="col-lg-4 col-sm-12">
                  <base-input
                    name="shippingpincode"
                    alternative
                    placeholder="Shipping Pin-code"
                    v-model="shipping_address.pincode"
                  ></base-input>
                </div>
                <div class="col-lg-4 col-sm-12">
                  <base-input
                    name="shippingcity"
                    alternative
                    placeholder="Shipping City"
                    v-model="shipping_address.city"
                  ></base-input>
                </div>
                <div class="col-lg-4 col-sm-12">
                  <base-input
                    name="shippingstate"
                    alternative
                    placeholder="Shipping State"
                    v-model="shipping_address.state"
                  ></base-input>
                </div>
                <div class="col-lg-4 col-sm-12">
                  <base-input
                    name="shippingcountry"
                    alternative
                    placeholder="Shipping Country"
                    v-model="shipping_address.country"
                  ></base-input>
                </div>
                <div class="col-lg-12 col-sm-12 text-center">
                  <button
                    @click.prevent="updatedDetail"
                    class="btn btn-primary"
                  >
                    Update
                  </button>
                  <button class="btn btn-danger">Cancel</button>
                </div>
              </div>
            </form>
          </div>
        </card>
      </div>
    </section>
  </div>
</template>
<script>
import { APIURLS } from "../api/constants.js";
import axios from "axios";
import moment from "moment";
export default {
  name: "profile",
  data() {
    return {
      ssame: false,
      name: null,
      email: null,
      phone: null,
      bill_address: {
        address: null,
        pincode: null,
        street: null,
        town: null,
        city: null,
        state: null,
        country: null,
      },
      shipping_address: {
        address: null,
        pincode: null,
        street: null,
        town: null,
        city: null,
        state: null,
        country: null,
      },
      userid: localStorage.getItem("customer_id"),
    };
  },
  methods: {
    copyBilling() {
      if (this.ssame) {
        for (let key in this.bill_address) {
          this.shipping_address[key] = this.bill_address[key];
        }
      } else if (!this.ssame) {
        for (let index in this.shipping_address) {
          this.shipping_address[index] = "";
        }
      }
    },
    getUserDetail() {
      var urltogouser = APIURLS.GET_GETUSER_DETAIL + "?userid=" + this.userid;
      //   axios.get(APIURLS.GET_GETUSER_DETAIL+"?userid"+this.userid)
      //   .then((response) => {
      //
      axios.get(urltogouser).then((response) => {
        // console.log(response.data[0]);
        this.name = response.data[0].namesurname;
        this.email = response.data[0].email;
        this.phone = response.data[0].phone;
        this.bill_address.address = response.data[0].billing_address
          ? response.data[0].billing_address
          : "";
        this.bill_address.street = response.data[0].billing_street
          ? response.data[0].billing_street
          : "";
        this.bill_address.town = response.data[0].billing_town
          ? response.data[0].billing_town
          : "";
        this.bill_address.pincode = response.data[0].billing_zip
          ? response.data[0].billing_zip
          : "";
        this.bill_address.city = response.data[0].billing_city
          ? response.data[0].billing_city
          : "";
        this.bill_address.state = response.data[0].billing_state
          ? response.data[0].billing_state
          : "";
        this.bill_address.country = response.data[0].billing_country
          ? response.data[0].billing_country
          : "";
        this.shipping_address.address = response.data[0].shipping_address
          ? response.data[0].shipping_address
          : "";
        this.shipping_address.street = response.data[0].shipping_street
          ? response.data[0].shipping_street
          : "";
        this.shipping_address.town = response.data[0].shipping_town
          ? response.data[0].shipping_town
          : "";
        this.shipping_address.pincode = response.data[0].shipping_zip
          ? response.data[0].shipping_zip
          : "";
        this.shipping_address.city = response.data[0].shipping_city
          ? response.data[0].shipping_city
          : "";
        this.shipping_address.state = response.data[0].shipping_state
          ? response.data[0].shipping_state
          : "";
        this.shipping_address.country = response.data[0].shipping_country
          ? response.data[0].shipping_country
          : "";
      });
    },
    updatedDetail() {
      var islog = localStorage.getItem("loggedIn");
      if (islog == "yes") {
        var formdata = new FormData();
        formdata.append("userid",this.userid);
        formdata.append("namesurname", this.name);
        formdata.append("email", this.email);
        formdata.append("phone", this.phone);
        formdata.append("billing_address", this.bill_address.address);
        formdata.append("billing_street", this.bill_address.street);
        formdata.append("billing_town", this.bill_address.town);
        formdata.append("billing_city", this.bill_address.city);
        formdata.append("billing_state", this.bill_address.state);
        formdata.append("billing_country", this.bill_address.country);
        formdata.append("billing_zip", this.bill_address.pincode);
        formdata.append("shipping_address", this.shipping_address.address);
        formdata.append("shipping_street", this.shipping_address.street);
        formdata.append("shipping_city", this.shipping_address.city);
        formdata.append("shipping_town", this.shipping_address.town);
        formdata.append("shipping_state", this.shipping_address.state);
        formdata.append("shipping_country", this.shipping_address.country);
        formdata.append("shipping_zip", this.shipping_address.pincode);
        // for (let [key, value] of formdata) {
        //   console.log(`${key}: ${value}`);
        // }
         axios.post(APIURLS.GET_USERDETAIL_UPDATE, formdata).then((response) => {
            this.showLoading = false;
            var data = response.data;
            if (data.success) {
           // console.log(data);
             this.$alertify.success("Data Updated..");
            }
         });
      } else {
        this.$modal.show("demo-login", {
          show: true,
        });
      }
    },
  },
  created() {
    this.getUserDetail();
  },
};
</script>
<style>
.mt-400 {
  margin-top: -34em !important;
}
.card-profile {
  background: linear-gradient(87deg, #f4f5f7 0, #f4f4f7 100%) !important;
}
textarea:focus-visible {
  outline: unset;
}
</style>
